import { CommonModule } from '@angular/common';
import { Component, inject, Output, EventEmitter, signal, OnInit, OnDestroy, viewChild, ElementRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIcon } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { NewRepChecklistService } from './new-rep-checklist-services/new-rep-checklist.service';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { HttpStatusCode } from 'axios';
import { NewRepChecklist } from './new-rep-checklist-interfaces/new-rep-checklist.interface';
import { HttpClient } from '@angular/common/http';
import { NewRepChecklistModel } from './new-rep-checklist-models/new-rep-checklist.model';
import { getChecklistItems } from './new-rep-checklist-interfaces/save-new-rep-checklist.interface';
@Component({
  selector: 'app-new-rep-checklist',
  imports: [
    MatCardModule,
    MatButtonModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    FormsModule,
    MatIcon,
    FormsModule,
    MatCheckboxModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
  templateUrl: './new-rep-checklist.component.html',
  styleUrl: './new-rep-checklist.component.scss',
  host: {
    '(document:keydown.escape)': 'onEscape()',
    '(document:fullscreenchange)': 'syncFullscreenState()',
  }
})
export class NewRepChecklistComponent implements OnInit, OnDestroy {
  @Output() next = new EventEmitter();

  private fb = inject(FormBuilder);
  private sanitizer = inject(DomSanitizer);
  private sessionStorageService = inject(SessionStorageService);
  private newRepChecklistService = inject(NewRepChecklistService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  setSprinner = signal(false);

  private readonly previewPanel = viewChild<ElementRef<HTMLElement>>('previewPanel');

  selectedDocument!: SafeResourceUrl;
  isPdf = false;
  selectedFileIndex = 0;
  selectedItemFiles: any[] = [];

  /** Preview panel state. */
  showPreview = false;
  isFullscreen = false;
  previewLoading = false;
  previewError = '';

  /** Links the open document back to its checklist row. */
  activePreviewIndex: number | null = null;
  activePreviewSn: number | null = null;
  activePreviewTitle = '';

  private objectUrl: string | null = null;

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;

  isPanning = false;
  private panOrigin: { x: number; y: number; left: number; top: number } | null = null;

  readonly message = 'This field is required.';
  protected viewfiles: NewRepChecklist[] = [];
  protected getchecklistItems: getChecklistItems[] = [];
  protected currentUserRole: string = "";
  data = history.state;
  viewId!: number;
  checklistData: any[] = [];
  isReadOnly = signal(false);
  iseditable = signal(false);


  // ✅ Static checklist data (NO state here)


  // ✅ Main Form
  assessmentForm: FormGroup = this.fb.group({
    name: [''],
    manager: [''],
    branch: [''],
    checklist: this.fb.array([]) // 🔥 dynamic
  });

  ngOnInit(): void {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.checklistData = [
      {
        section: 'A) Minimum Documents Required for Due Diligence & Reference Checks',
        note1: '1) On the Application Form, please ensure there are no date gaps in the Employment History section',
        note2: '2) Reference check will commence after the 1st 10 documents (i.e S/No. 1-10) are received.',
        items: [
          {
            id: 1,
            index: 0,
            title: "Photocopy of NRIC / Passport / FIN / Other ID Document (*)",
            files: []
          },
          {
            id: 2,
            index: 1,
            title: "Academic Certificates and transcripts (*)",
            files: []
          },
          {
            id: 3,
            index: 2,
            title: "Written Authority to conduct inquiry into previous employment",
            files: []
          },
          {
            id: 4,
            index: 3,
            title: "Credit Bureau (Singapore) Report valid within the last 3 months",
            files: []
          },
          {
            id: 5,
            index: 4,
            title: "SCI Module 5 / RES5 Results Slip (*)",
            files: []
          },
          {
            id: 6,
            index: 5,
            title: "SCI Module 9 Results Slip (*) & SCI Module 9A Results Slip (*) OR SCI Module CM-LIP Results Slip (*)",
            files: []
          },
          {
            id: 7,
            index: 6,
            title: "Health Insurance (HI) Results Slip (*)",
            files: []
          },
          {
            id: 8,
            index: 7,
            title: "Past 15 Months CPF Transaction History (All transactions)",
            files: []
          },
          {
            id: 9,
            index: 8,
            title: "Passport-sized Photo (Color) – Digital or or high-resolution self-taken photo (Face only)",
            files: []
          },
          {
            id: 10,
            index: 9,
            title: "Letter of Authorization to CPF Board",
            files: []
          },
          {
            id: 11,
            index: 10,
            title: "Photocopy of Bank A/C Details showing Name & Account No.",
            files: []
          },
          {
            id: 12,
            index: 11,
            title: "Acknowledgement of Transfer Rules Form",
            files: []
          }
        ]
      },
      {
        section: 'B) Subsequent Documents Required for Assessment (ONLY IF APPLICABLE)',
        note1: '1) For applicants applying for any of S/N 1-3, submission of Item 4 is mandatory.',
        note2: '2) Only by submitting items S/N 7, 8, and 9 qualifies you for a General Insurance license.',
        note3: '3) Applicable and mandatory if applicants have Business Interest/Shareholding/Ownership',
        items: [
          {
            id: 1,
            index: 12,
            title: 'SCI Module 6 / CM-EIP Results Slip (*) if applicable',
            files: []
          },
          {
            id: 2,
            index: 13,
            title: 'SCI Module 6A / CM-SIP Results Slip (*) if applicable',
            files: []
          },
          {
            id: 3,
            index: 14,
            title: 'SCI Module CM-CMP Results Slip (*) if applicable',
            files: []
          },
          {
            id: 4,
            index: 15,
            title: 'Letter of Undertaking for Register of Interests in Securities (Note: Applies only if submit CM-EIP & CM-SIP Results Slips)',
            files: []
          },
          {
            id: 5,
            index: 16,
            title: 'SCI Module 8 Results Slip (*) & SCI Module 8A Results Slip (*) or SCI Module CM-CIS Results Slip (*) if applicable',
            files: []
          },
          {
            id: 6,
            index: 17,
            title: 'SCI Module CM-LIC Results Slip (*) if applicable',
            files: []
          },
          {
            id: 7,
            index: 18,
            title: 'Basic Insurance Concepts and Principles (BCP) Results Slip (*)',
            files: []
          },
          {
            id: 8,
            index: 19,
            title: 'Personal General Insurance (PGI) Results Slip (*)',
            files: []
          },
          {
            id: 9,
            index: 20,
            title: 'Commercial General Insurance (CommGI) Results Slip (*)',
            files: []
          },
          {
            id: 10,
            index: 21,
            title: 'Professional Certificates (*)',
            files: []
          },
          {
            id: 11,
            index: 22,
            title: 'Business Interest Declaration form & ACRA BizFile',
            files: []
          }
        ]
      }
    ];

    this.initChecklist();
    this.viewId = this.data.id;
    this.isReadOnly.set(this.data.isReadOnly);
    this.iseditable.set(this.data.iseditable);
    if ((this.currentUserRole == 'DSU' || this.currentUserRole == 'DSU Manager') && this.iseditable()) {
      this.isReadOnly.set(false);
    }
    if (this.isReadOnly() == true) {
      this.assessmentForm?.disable();
    } else {
      this.assessmentForm?.enable();
    }
    this.viewChecklistDocuments();
    this.getChecklistItems();
  }

  flatChecklist: any[] = [];

  private initChecklist() {

    this.flatChecklist = [];

    this.checklistData.forEach(section => {
      section.items.forEach((item: any) => {
        this.flatChecklist.push({
          ...item,
          section: section.section
        });
      });
    });

    const checklistArray = this.flatChecklist.map((item, index) =>
      this.fb.group({
        rmCheck: index <= 11 ? [false, [Validators.requiredTrue]] : [false]
      })
    );

    this.assessmentForm.setControl(
      'checklist',
      this.fb.array(checklistArray)
    );
  }
  onCheckboxChange(checked: boolean, index: number) {

    const checkbox = this.assessmentForm.get('checklist') as FormArray;

    if (checked) {
      checkbox.at(index)?.get('rmCheck')?.patchValue(true);
      checkbox.at(index)?.get('rmCheck')?.markAsUntouched();
    } else {
      checkbox?.at(index)?.get('rmCheck')?.patchValue(false);
      checkbox?.at(index)?.get('rmCheck')?.markAsTouched();
    }
  }


  // ✅ Getter
  get checklistForm(): FormArray {
    return this.assessmentForm.get('checklist') as FormArray;
  }
  // ✅ Actions
  /** Opens (or retargets) the side-by-side preview for a checklist row. */
  previewDoc(item: any): void {
    if (!item?.files?.length) {
      return;
    }

    this.activePreviewIndex = item.index;
    this.activePreviewSn = item.id;
    this.activePreviewTitle = item.title;

    this.selectedItemFiles = item.files;
    this.showPreview = true;
    void this.loadFile(0);
  }

  async loadFile(index: number): Promise<void> {
    const file = this.selectedItemFiles?.[index];
    if (!file) {
      return;
    }

    this.selectedFileIndex = index;
    this.resetZoom();
    this.isPdf = !!file.name && file.name.toLowerCase().endsWith('.pdf');

    if (!file.name) {
      this.previewError = 'This file has no name and cannot be previewed.';
      return;
    }

    this.previewError = '';
    this.previewLoading = true;
    this.releaseObjectUrl();
    this.selectedDocument = '';

    try {
      const blob = await this.newRepChecklistService.viewChecklistdocuments(file.fileid);

      // Guard against a slow response landing after the user switched files.
      if (this.selectedFileIndex !== index) {
        return;
      }

      this.objectUrl = URL.createObjectURL(blob);
      this.selectedDocument = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
    } catch (error) {
      console.error(error);
      if (this.selectedFileIndex === index) {
        this.previewError = 'We couldn’t load this document. Please try again.';
      }
    } finally {
      if (this.selectedFileIndex === index) {
        this.previewLoading = false;
      }
    }
  }

  get zoomPercent(): number {
    return Math.round(this.zoomLevel * 100);
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  onWheelZoom(event: WheelEvent): void {
    if (this.isPdf || !event.ctrlKey) {
      return;
    }

    event.preventDefault();
    if (event.deltaY < 0) {
      this.zoomIn();
    } else {
      this.zoomOut();
    }
  }

  /** Drag-to-pan a zoomed-in document; the scroll container does the work. */
  onPanStart(event: PointerEvent, scroller: HTMLElement): void {
    if (this.isPdf || this.zoomLevel <= 1 || event.button !== 0) {
      return;
    }

    this.panOrigin = {
      x: event.clientX,
      y: event.clientY,
      left: scroller.scrollLeft,
      top: scroller.scrollTop,
    };
    this.isPanning = true;
    scroller.setPointerCapture(event.pointerId);
  }

  onPanMove(event: PointerEvent, scroller: HTMLElement): void {
    if (!this.panOrigin) {
      return;
    }

    scroller.scrollLeft = this.panOrigin.left - (event.clientX - this.panOrigin.x);
    scroller.scrollTop = this.panOrigin.top - (event.clientY - this.panOrigin.y);
  }

  onPanEnd(event: PointerEvent, scroller: HTMLElement): void {
    if (!this.panOrigin) {
      return;
    }

    this.panOrigin = null;
    this.isPanning = false;
    if (scroller.hasPointerCapture(event.pointerId)) {
      scroller.releasePointerCapture(event.pointerId);
    }
  }

  async toggleFullscreen(): Promise<void> {
    const panel = this.previewPanel()?.nativeElement;
    if (!panel) {
      return;
    }

    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      } else {
        await panel.requestFullscreen();
      }
    } catch (error) {
      console.error(error);
    }
  }

  syncFullscreenState(): void {
    this.isFullscreen = !!this.previewPanel()
      && document.fullscreenElement === this.previewPanel()!.nativeElement;
  }

  onEscape(): void {
    // In full screen the browser handles Escape itself — don't also close the panel.
    if (this.isFullscreen || !this.showPreview) {
      return;
    }

    this.closePreview();
  }

  closePreview(): void {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch((error) => console.error(error));
    }

    this.showPreview = false;
    this.selectedDocument = '';
    this.selectedItemFiles = [];
    this.selectedFileIndex = 0;
    this.activePreviewIndex = null;
    this.activePreviewSn = null;
    this.activePreviewTitle = '';
    this.previewError = '';
    this.previewLoading = false;
    this.isPanning = false;
    this.panOrigin = null;
    this.releaseObjectUrl();
    this.resetZoom();
  }

  private releaseObjectUrl(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }

  ngOnDestroy(): void {
    this.releaseObjectUrl();
  }


  async viewChecklistDocuments() {
    this.setSprinner.set(true);
    const responseData = await this.newRepChecklistService
      .viewChecklistdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      // console.log(responseData);
      this.viewfiles = responseData.data.responsedata;
      // console.log(this.viewfiles);

      this.checklistData.forEach((section: any) => {

        section.items.forEach((item: any) => {

          // Match based on item index / id / title
          if (item.index === 0) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'Attachment(NRIC)' ||
                file.onboardingDocumentType === 'Attachment(FIN or Passport)'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 1) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'Academic' ||
                file.onboardingDocumentType === 'academic_transcript'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 2) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'writtenAuthoritypreviousemployment'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 3) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'creditBureauReport'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 4) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'M5/RES5'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 5) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'M9' ||
                file.onboardingDocumentType === 'M9A' ||
                file.onboardingDocumentType === 'CM-LIP'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 6) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'HI'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 7) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'CPFTransactionHistory'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 8) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'passportsizedPhoto'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 9) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'letterofAuthorizationtoCPFBoard'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 10) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'Attachement(Bank Account)'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 11) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'acknowledgementofTransferRulesForm'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 12) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'CM-EIP / M6'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 13) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'CM-SIP / M6A'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 14) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'CM-CMP'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 15) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'LetterofUndertakingforRegisterofInterestsinSecurities'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 16) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'M8' ||
                file.onboardingDocumentType === 'M8A' ||
                file.onboardingDocumentType === 'CM-CIS'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 17) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'CM-LIC'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 18) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'BCP'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 19) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'PGI'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 20) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'CommGI'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 21) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'Professional_Qualification'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

          if (item.index === 22) {

            const files = this.viewfiles
              .filter((file: any) =>
                file.onboardingDocumentType === 'businessInterests_1' ||
                file.onboardingDocumentType === 'businessInterests_3' ||
                file.onboardingDocumentType === 'businessInterests_1_2' ||
                file.onboardingDocumentType === 'businessInterests_3_2'
              )
              .map((file: any) => ({
                fileid: file.id,
                name: file.fileName,
                url: file.filePath
              }));

            item.files = [...(item.files || []), ...files];
          }

        });



      });

      // console.log(this.checklistData)
      this.assessmentForm.controls['name']?.setValue(this.viewfiles[0]?.name);
      this.assessmentForm.controls['manager']?.setValue(this.viewfiles[0]?.manager);
      this.assessmentForm.controls['branch']?.setValue(this.viewfiles[0]?.branch);
      // console.log(this.checklistData);

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async getChecklistItems() {
    this.setSprinner.set(true);
    const responseData = await this.newRepChecklistService
      .getChecklistItems(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.getchecklistItems = responseData.data.responsedata;
      this.getchecklistItems = this.getchecklistItems.filter(
        x => x.categoryName.startsWith('minimumDocumentCheck_') || x.categoryName.startsWith('subsequentDocumentsCheck_')
      );
      const preferredOrder = [
        "minimumDocumentCheck_",
        "subsequentDocumentsCheck_",
      ];

      const getCategoryOrder = (categoryName = "") => {
        const index = preferredOrder.findIndex(prefix =>
          categoryName.startsWith(prefix)
        );
        return index === -1 ? preferredOrder.length : index;
      };

      const getSuffixNumber = (categoryName = "") => {
        const match = categoryName.match(/_(\d+)$/);
        return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
      };

      this.getchecklistItems.sort((a, b) => {
        const orderA = getCategoryOrder(a.categoryName);
        const orderB = getCategoryOrder(b.categoryName);

        if (orderA !== orderB) {
          return orderA - orderB;
        }

        return getSuffixNumber(a.categoryName) - getSuffixNumber(b.categoryName);
      });

      this.getchecklistItems.forEach((item, index) => {
        if (index <= 23) {
          this.checklistForm.at(index)?.patchValue({
            rmCheck: this.getchecklistItems[index]?.isCompleted,
          })
        }
      });

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  // ✅ Submit
  async saveAndContinue() {
    this.setSprinner.set(true);
    let saveNewRepchecklist = new NewRepChecklistModel();
    saveNewRepchecklist.setonboarding_id(this.viewId);
    const newrepChecklist = this.checklistForm.controls.map((control: any, index: number) => ({

      id: this.getchecklistItems[index]?.id,
      question_id: 0,
      category_name: index <= 11 ? 'minimumDocumentCheck_' + (index + 1) : index > 11 && index < 23 ? 'subsequentDocumentsCheck_' + (index - 11) : 'actionbybdm_' + (index - 22),
      is_completed: control.get('rmCheck').value,
      response_value: '',
      onboarding_id: this.viewId.toString(),
      updated_by_role: this.sessionStorageService.getCurrentUserRole(),
    }));
    saveNewRepchecklist.setChecklist([...newrepChecklist]);
    const responseData = await this.newRepChecklistService
      .savenewRepChecklistItems(saveNewRepchecklist)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("Application saved successfully!");
      this.getChecklistItems();
      // this.router.navigate(['/agent-onboarding']);
      this.next.emit();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }
}